import type { CodeWidgetData } from '@web/widgets/code/type';

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { WebBaseControlComponent } from '@web/widgets/common/abstract/web-base-control.component';
import { CommonElementsModule } from '@web/widgets/common/common-elements.module';

@Component({
    selector: 'web-code-control',
    templateUrl: './code-control.component.html',
    styleUrls: ['./code-control.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonElementsModule],
})
export class CodeControlComponent extends WebBaseControlComponent<CodeWidgetData> {
    protected initForm(): void {
        this.controlForm = this.fb.group({});
    }

    protected setFormData(): void {
        this.controlForm.patchValue({}, { emitEvent: false });
    }
}
